import BnumElement from 'components/bnum-element';
import { BackgroundChangedEvent } from './types';
import { EVENT_DEFAULT } from 'core/utils/constants/constants';
import { EVENT_BACKGROUND_CHANGED } from './constants';

export function onBackgroundChangedInitializer(
	event: BackgroundChangedEvent,
	instance: BnumElement,
) {
	event.add(EVENT_DEFAULT, newBackground => {
		instance.trigger(EVENT_BACKGROUND_CHANGED, { newBackground });
	});
}
